module.exports = __webpack_public_path__ + "static/media/forgot_password_attempts.544db616.png";